import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-mk-callback',
    template: `<div></div>`,
    standalone: false
})
export class CallbackComponent implements OnInit {
  ngOnInit(): void {}
}
